import React, { Component } from 'react';
import { connect } from 'react-redux';
import FlatButton from 'material-ui/FlatButton';
import {Card, CardActions, CardHeader, CardText} from 'material-ui/Card';
import { quoteRequest } from '../redux/actions';
import PayIcon from 'material-ui/svg-icons/action/payment';
import FeedbackIcon from 'material-ui/svg-icons/action/feedback';

const ServiceCard = ({onGetQuote, service, user, color}) =>
<Card style={{marginBottom: "1rem", backgroundColor:"#f3f2f0"}}>
    <CardHeader
        title={service.name}
        subtitle={ service.price ? service.price : "Quote Pending..."}
        actAsExpander={true}
        showExpandableButton={true}
        style={{backgroundColor: color}}
    />
    <CardActions>
        <FlatButton label="Pay Bill" disabled={service.price ? false : true} icon={<PayIcon />} />
        <FlatButton label="Write Review" disabled={service.price ? false : true} icon={<FeedbackIcon />}/>
    </CardActions>
    <CardText expandable={true}>
        { service.price ? '' : 
            "Our service specalist has not conducted your property evaluation yet. An email will be sent once the evaluation has been compleated."
        }
    </CardText>
</Card>

const mapStateToProps = ({user}) => ({user});

const mapDispatchToProps = dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ServiceCard);


// WEBPACK FOOTER //
// ./src/components/ActiveServiceCard.js